"use client";

import React from "react";
import PropTypes from "prop-types";

export default function TextBox({ id, name, value, onChange, onBlur, placeholder = "", className = "", type = "text", ...rest }) {
  return (
    <input
      id={id || name}
      name={name}
      type={type}
      value={value}
      onChange={onChange}
      onBlur={onBlur}
      placeholder={placeholder}
      className={className}
      autoComplete="off"
      {...rest}
    />
  );
}

TextBox.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string,
  value: PropTypes.any,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  placeholder: PropTypes.string,
  className: PropTypes.string,
  type: PropTypes.string,
};
